import React, { useState } from 'react'
import HeaderIcon from '../../assets/images/header-icon/expert-type.png'
import { pexios } from '../../utils/functions'
import { history } from '../../utils/variables'
import { useDispatch, useSelector } from 'react-redux'
import { setRouterData } from '../../redux/actions'
import OnlineExpert from '../../assets/images/online-expert.png'
import AtPlaceExpert from '../../assets/images/atPlace-expert.png'


function AssessType() {
    const {routerData ,location} = useSelector(store => store);
    const dispatch = useDispatch()
    const [expertType,setExpertType] = useState('')
    function SelectOnlineExpert(){
        const data =  {
            accident_id : routerData.id,
            ...location
            // state_id : location.state_id,
            // city_id: location.city_id,
            // lat : location.lat,
            // lng : location.lng
          }
        pexios('/api/select_online_expert','post',data)
        .then(()=>{
            dispatch(setRouterData({ ...routerData,state: 3}));
            setTimeout(()=>history.push('/accident-report'));
        })
    }
  return (
    <div className='content assess-type'>
        <div className='title-image mt20'>
            <img src={HeaderIcon} alt="icon"/>
        </div>
        <p className='guide-text mx10 mt20 mb40'>
        بیمه گذار محترم ، شما می توانید یکی از روش های زیر را برای کارشناسی حادثه خود انتخاب نمایید.
        </p>
        <div className={`option ${expertType === 'online'? 'active' :''}`} onClick={()=>setExpertType('online')}>
            <p className='title'>ارزیابی توسط کارشناسان آنلاین با مشارکت شما</p>
            <img src={OnlineExpert} alt="img"/>
        </div>
        <div className={`option ${expertType === 'at-place'? 'active' :''}`} onClick={()=>setExpertType('at-place')}>
            <p className='title'>ارزیابی توسط کارشناس حضوری</p>
            <img src={AtPlaceExpert} alt="img"/>
        </div>
        <div className='d-flex justify-center mt60'>
            <button className={`btn btn-circle w-50 m10 btn-orange`} onClick={()=>history.push('/get_location')}>تغییر مکان حادثه  </button>
            <button className={`btn btn-circle w-50 m10 ${expertType? 'btn-white-purple btn-bold':'btn-disable'}`} 
                onClick={()=> expertType === 'online' ? SelectOnlineExpert() : history.push('/select-expert')}>مرحله بعد  </button>
        </div>
    </div>
  )
}

export default AssessType